import { jsxs, jsx } from 'react/jsx-runtime';
import { Pagination, styled } from '@teko/ds-desktop';
import { P as ProductGrid } from './ProductGrid-1f86a2e0.js';
import React from 'react';
import { t } from './i18n.es.js';
import { B as BlockHeader } from './BlockHeader-4332d564.js';

const JustForYou = ({ header, products, productsPerRow, pagination, }) => {
    if (!products || !products.length)
        return null;
    return (jsxs(React.Fragment, { children: [jsxs(Wrapper, { children: [jsx(BlockHeader, Object.assign({}, header, { title: header.title || t('Sản phẩm dành cho bạn') }), void 0), jsx(ProductGrid, { products: products, productsPerRow: productsPerRow || 5, regionName: "forYouListProduct" }, void 0)] }, void 0), jsx(Pagination, Object.assign({}, pagination), void 0)] }, void 0));
};
const Wrapper = styled.div `
  background: white;
  border-radius: 0.5rem;
  margin-bottom: ${({ theme }) => theme.spacing.s16};
`;

export { JustForYou as J };
